'use client';

import { useState, useEffect } from 'react';
import Header from '@/components/common/Header';
import HeroSection from './HeroSection';
import ServicesOverview from './ServicesOverview';
import TrustIndicators from './TrustIndicators';
import ServiceAreas from './ServiceAreas';
import Testimonials from './Testimonials';
import CTASection from './CTASection';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';

export default function HomepageInteractive() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <main>
          <HeroSection />
          <ServicesOverview />
          <TrustIndicators />
          <ServiceAreas />
          <Testimonials />
          <CTASection />
        </main>
        <Footer />
        <WhatsAppButton />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <HeroSection />
        <ServicesOverview />
        <TrustIndicators />
        <ServiceAreas />
        <Testimonials />
        <CTASection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}